export default __webpack_public_path__ + "cf1cae820b179fa49cf39b0e7214e92e.png";